import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { Swal } from "../../../services/SwalTemplates";
import {
  Background,
  Container,
  Titulo,
  Button,
  Form,
  Table,
  Row,
} from "./style";
import DiasFechamento from "../../../services/DiasFimMes";

export default function Home() {
  const navigate = useNavigate();
  const [homeSec, setHomeSec] = useState([]);
  const [dataInicio, setDataInicio] = useState("");
  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    api
      .get(`/sec/home/?dataInicio=${dataInicio}`)
      .then((response) => {
        setHomeSec(response.data.grade);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
  }, [dataInicio, navigate, trigger]);

  return (
    <Background>
      <Container>
        <Form>
          <Row>
            <form>
              <br />
              <div>
                <label>Aulas de</label>
                <input
                  type="date"
                  name="date"
                  id=""
                  value={dataInicio}
                  onChange={(e) => setDataInicio(e.target.value)}
                />
                <Button
                  type="button"
                  onClick={() => {
                    setTrigger(!trigger);
                  }}
                >
                  Mostrar
                </Button>
              </div>
            </form>
            <Titulo>
              <h3>
                <DiasFechamento />
              </h3>
            </Titulo>
          </Row>
        </Form>
        <Table>
          <table>
            <thead
              role="grid"
              style={{ maxWidth: "100%", tableLayout: "fixed" }}
            >
              <tr>
                <th>Unidade</th>
                <th>Turma</th>
                <th>Dia</th>
                <th>Início</th>
                <th>Fim</th>
                <th>Professor</th>
              </tr>
            </thead>
            <tbody>
              {homeSec.map((h, i) => (
                <tr key={i}>
                  <td
                    data-title="Unidade"
                    title={h.unidade}
                    className="td-left"
                  >
                    {h.unidade.slice(0, 30)}
                    {h.unidade.length > 30 && "..."}
                  </td>
                  <td
                    data-title="Turma"
                    className="td-left"
                    title={h.turma
                      .replaceAll("TÉCNICO EM ", "")
                      .replaceAll("CURSO TÉCNICO ", "")
                      .replaceAll("TECNÓLOGO EM ", "")}
                  >
                    {h.turma
                      .replaceAll("TÉCNICO EM ", "")
                      .replaceAll("CURSO TÉCNICO ", "")
                      .replaceAll("TECNÓLOGO EM ", "")
                      .slice(0, 60)}
                    {h.turma
                      .replaceAll("TÉCNICO EM ", "")
                      .replaceAll("CURSO TÉCNICO ", "")
                      .replaceAll("TECNÓLOGO EM ", "").length > 60 && "..."}
                  </td>
                  <td data-title="Dia da semana">{h.dia_semana}</td>
                  <td data-title="Horário início">{h.horario_inicio}</td>
                  <td data-title="Horário fim">{h.horario_fim}</td>
                  <td data-title="Professor" className="td-left">
                    {h.professor}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Table>
      </Container>
    </Background>
  );
}
